import { render, staticRenderFns } from "./Create.vue?vue&type=template&id=76bc83a7&scoped=true"
import script from "./Create.vue?vue&type=script&lang=js"
export * from "./Create.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76bc83a7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/crm1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76bc83a7')) {
      api.createRecord('76bc83a7', component.options)
    } else {
      api.reload('76bc83a7', component.options)
    }
    module.hot.accept("./Create.vue?vue&type=template&id=76bc83a7&scoped=true", function () {
      api.rerender('76bc83a7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/crm/product/Create.vue"
export default component.exports